import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ComponentsService } from 'src/app/components.service';

@Component({
    selector: 'app-product-man',
    templateUrl: './product-man.component.html',
    styleUrls: ['./product-man.component.css']
})
export class ProductManComponent implements OnInit {
    loaded: boolean = false;
    ELEMENT_DATA: Client[] = [];
    perms;
    dataSource;

    constructor(private service: ComponentsService) {}

    ngOnInit(): void {
        let clientUuid = this.service.getUsersPerm().clientUuid;
        this.perms = this.service.getUsersPerm();
        this.service.getGames(clientUuid).subscribe((games) => {
            this.ELEMENT_DATA = games.data;

            this.dataSource = new MatTableDataSource<Client>(this.ELEMENT_DATA);
        });
        //KADA SE MENJA KLIJENT (  SUPER ADMIN );
        this.service.clientChanged.subscribe((client) => {
            this.service.getGames(client.clientUuid).subscribe((games) => {
                this.ELEMENT_DATA = games.data;
                this.dataSource = new MatTableDataSource<Client>(
                    this.ELEMENT_DATA
                );
            });
        });
    }
    //KADA SE MENJA KLIJENT (  SUPER ADMIN );
    displayedColumns: string[] = [
        'code',
        'name',
        'active',
        'settings',
        'preview'
    ];
    // dataSource = new MatTableDataSource<Client>(this.ELEMENT_DATA);
}

export interface Client {
    code: string;
    name: string;
    active: boolean;
    settings: string;
    preview: string;
}
